import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react';
import { NavLink as NLink } from 'react-router-dom';

export const NavLink = ({
  icon,
  link,
  title,
  count = 0,
  isCollapsed,
  testID = 'nav-link',
  isCustomActive = false,
}) => {
  return (
    <Tooltip
      isDisabled={!isCollapsed}
      label={title}
      arrowSize={8}
      hasArrow
      placement="right"
      borderRadius="4px"
      variant="default"
    >
      <NLink
        to={link}
        className={(isActive) =>
          'app-nav' + (isActive || isCustomActive ? ' active' : '')
        }
      >
        <Flex
          className="nav"
          alignItems="center"
          justifyContent="space-between"
          cursor="pointer"
          p="8px 12px"
          mb="2px"
          borderRadius="6px"
          _hover={{ bg: '#FFF' }}
          minHeight="42px"
        >
          <Flex alignItems="center">
            <Icon
              as={icon}
              width="18px"
              height="18px"
              color={'primary-900'}
              mr="10px"
              data-test-id={`${testID}-icon`}
            />
            {!isCollapsed && (
              <Text
                flex="1"
                fontSize="14px"
                fontWeight="regular"
                whiteSpace="nowrap"
                color={'primary-900'}
                data-test-id={testID}
              >
                {title}
              </Text>
            )}
          </Flex>
          {isCollapsed && count > 0 && (
            <Box
              bg="#444CE7"
              padding="3px"
              borderRadius="100%"
              position="relative"
              left="-8px"
              top="-3px"
            ></Box>
          )}
          {!isCollapsed && count > 0 && (
            <Flex
              px="8px"
              py="4px"
              h="24px"
              w={count / 100 >= 1 ? 'fit-content' : '24px'}
              borderRadius={count / 100 >= 1 ? '16px' : '100%'}
              fontSize="xs"
              alignItems="center"
              justifyContent="center"
              bg={'primary-100'}
              color={'primary-700'}
              fontWeight="semiBold"
            >
              {count}
            </Flex>
          )}
        </Flex>
      </NLink>
    </Tooltip>
  );
};
